import AdminMessagesInbox from '../components/AdminMessagesInbox';

export default function AdminPartnerMessages() {
  return <AdminMessagesInbox type="partner" title="Partner Messages" />;
}
